const ProgressStates = {
  RUNNING: 0,
  PAUSED: 1,
  FINISHED: 2,
  FAILED: 3,
  PAUSING: 4,
};

export default ProgressStates;
